import { useContext } from 'react';
import { BridgeContext, type BridgeContextValue } from './BridgeProvider';

export const useBridge = (): BridgeContextValue => {
  const ctx = useContext(BridgeContext);
  if (!ctx) {
    throw new Error('useBridge must be used inside <BridgeProvider>');
  }
  return ctx;
};
